import axios from 'src/utils/axios';

class TradingApi {
  async getPositions(params = {}) {
    const response = await axios.get(`/client/client_account/finance/positions`, { params });
    return response;
  }

  async getBalance(params = {}) {
    const response = await axios.get('/client/client_account/finance/balance', { params });
    return response;
  }

  async createTradingAccount(data = {}) {
    const response = await axios.post('/client/client_account/finance/trading_accounts', data);
    return response;
  }

  async updateTradingAccount(id, data = {}) {
    const response = await axios.put(`/client/client_account/finance/trading_accounts/${id}`, data);
    return response;
  }
}

export const tradingApi = new TradingApi();
